export const LICENSE_COUNT_DAYS_TO_EXPIRATION = 'at/workSchedule/LICENSE_COUNT_DAYS_TO_EXPIRATION'


// WEBPACK FOOTER //
// ./web/js/components/licenseCountDownTip/actionTypes.js